
import Dashboard from "@/Component/Dashboard";
import type { Metadata } from "next";

export const metadata: Metadata = {
    title: "Dashboard | Connector Club",
};

const DashboardPage = () => {
    return (
        <Dashboard />
    )
}

export default DashboardPage
